module.exports = __webpack_public_path__ + "static/media/18ECA2.54be0e04.jpg";